import { commonUtil } from '@/util'
const request = {}

request.createRequest = function (params) {
  return {
    trackingNumber: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line1.trackingNumber
    ),
    shipDestOrganizationName: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.organizationName
    ),
    shipDestName: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.fullName
    ),
    shipDestCountryId: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.country.value
    ),
    shipDestPostalCode: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.postalCode
    ),
    shipDestRegionId: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(params.pageInfoData.line2.region, true)
    ),
    shipDestRegion: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(params.pageInfoData.line2.region, false)
    ),
    shipDestAddress1: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.address1
    ),
    shipDestAddress2: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.address2
    ),
    shipDestCountryCode: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.phone.countryCode.value
    ),
    shipDestPhoneNumber: commonUtil.nullEmptyFormatNull(
      params.pageInfoData.line2.phone.phoneNumber
    ),
    note: commonUtil.nullEmptyFormatNull(params.pageInfoData.line1.remarks.data)
  }
}
export default { request }
